<ng-container *transloco="let t">
<div *ngIf="this.isPopUp !== true">
  <nz-page-header nzBackIcon class="bg-slate-100" [nzGhost]="false">
    <nz-page-header-title *ngIf="isAdd" class="text-primary">
      {{ t('customers.addEdit.addTitle') }}
    </nz-page-header-title>
    <nz-page-header-title *ngIf="!isAdd" class="text-primary">
      {{ t('customers.addEdit.editTitle') }}
    </nz-page-header-title>
  </nz-page-header>
</div>

<div class="my-8">
  <div [ngClass]="this.isPopUp === true ? 'grid grid-cols-1' : 'grid xl:grid-cols-3 md:grid-cols-2'">
    <div>
      <form nz-form [formGroup]="customerForm">

        <nz-form-item class="lg:flex">
          <nz-form-label
            [ngClass]="this.isPopUp === true ? 'w-3/12' : 'w-3/12 md:w-4/12 lg:w-2/5'"
            nzRequired
            nzFor="first_name">
            {{ t('customers.addEdit.firstName') }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="firstNameCheck">
            <input
              type="text"
              nz-input
              class="w-full"
              formControlName="first_name"
              [placeholder]="t('customers.addEdit.placeholders.firstName')"/>
          </nz-form-control>
          <ng-template #firstNameCheck>
            <span *ngIf="formErrors.first_name.required">
              {{ t('customers.addEdit.errors.firstNameRequired') }}
            </span>
          </ng-template>
        </nz-form-item>

        <nz-form-item class="lg:flex">
          <nz-form-label
            [ngClass]="this.isPopUp === true ? 'w-3/12' : 'w-3/12 md:w-4/12 lg:w-2/5'"
            nzRequired
            nzFor="last_name">
            {{ t('customers.addEdit.lastName') }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="lastNameCheck">
            <input
              type="text"
              nz-input
              class="w-full"
              formControlName="last_name"
              [placeholder]="t('customers.addEdit.placeholders.lastName')"/>
          </nz-form-control>
          <ng-template #lastNameCheck>
            <span *ngIf="formErrors.last_name.required">
              {{ t('customers.addEdit.errors.lastNameRequired') }}
            </span>
          </ng-template>
        </nz-form-item>

        <nz-form-item class="lg:flex">
          <nz-form-label
            [ngClass]="this.isPopUp === true ? 'w-3/12' : 'w-3/12 md:w-4/12 lg:w-2/5'"
            nzFor="email">
            {{ t('customers.addEdit.email') }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="emailCheck">
            <input
              nz-input
              class="w-full"
              formControlName="email"
              [placeholder]="t('customers.addEdit.placeholders.email')"/>
          </nz-form-control>
          <ng-template #emailCheck>
            <span *ngIf="formErrors.email.email">
              {{ t('customers.addEdit.errors.emailInvalid') }}
            </span>
          </ng-template>
        </nz-form-item>

        <nz-form-item class="lg:flex">
          <nz-form-label
            [ngClass]="this.isPopUp === true ? 'w-3/12' : 'w-3/12 md:w-4/12 lg:w-2/5'"
            nzRequired
            nzFor="country">
            {{ t('customers.addEdit.country') }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="countryCheck">
            <nz-select
              formControlName="country"
              [nzPlaceHolder]="t('customers.addEdit.placeholders.country')"
              nzShowSearch>
              <nz-option
                *ngFor="let data of orderByName(countries)"
                [nzValue]="data.code"
                [nzLabel]="data.emoji + ' ' + data.name"></nz-option>
            </nz-select>
          </nz-form-control>
          <ng-template #countryCheck>
            <span *ngIf="formErrors.country.required">
              {{ t('customers.addEdit.errors.countryRequired') }}
            </span>
          </ng-template>
        </nz-form-item>

        <nz-form-item class="lg:flex">
          <nz-form-label
            [ngClass]="this.isPopUp === true ? 'w-3/12' : 'w-3/12 md:w-4/12 lg:w-2/5'"
            nzFor="contact">
            {{ t('customers.addEdit.contactNumber') }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="contactNumberCheck">
            <nz-input-group [nzAddOnBefore]="selectBefore">
              <ng-template #selectBefore>
                <nz-select
                  nzAllowClear
                  nzShowSearch
                  [nzPlaceHolder]="t('customers.addEdit.placeholders.dialCode')"
                  formControlName="dialCode"
                  style="width: 100px"
                  [nzDropdownStyle]="{ width: '250px' }">
                  <nz-option
                    *ngFor="let data of orderByName(countries)"
                    [nzValue]="data.dialing_code"
                    nzCustomContent="true"
                    [nzLabel]="data.dialing_code + ' ' + data.name">
                    <div class="flex">
                      <img [src]="data.image" width="20" height="20" alt="country">
                      <span class="mx-2">{{ data.name }}</span>
                      <span>{{ data.dialing_code }}</span>
                    </div>
                  </nz-option>
                </nz-select>
              </ng-template>
              <input
                nz-input
                formControlName="contact"
                [placeholder]="t('customers.addEdit.placeholders.contact')"/>
            </nz-input-group>
            <ng-template #contactNumberCheck>
              <span *ngIf="formErrors.contact.pattern">
                {{ t('customers.addEdit.errors.contactInvalid') }}
              </span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="lg:flex">
          <nz-form-label
            [ngClass]="this.isPopUp === true ? 'w-3/12' : 'w-3/12 md:w-4/12 lg:w-2/5'"
            nzRequired
            nzFor="active">
            {{ t('customers.addEdit.status') }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="activeCheck">
            <nz-select
              formControlName="active"
              [nzPlaceHolder]="t('customers.addEdit.placeholders.status')">
              <nz-option [nzValue]="true" [nzLabel]="t('customers.addEdit.statusOptions.active')"></nz-option>
              <nz-option [nzValue]="false" [nzLabel]="t('customers.addEdit.statusOptions.inactive')"></nz-option>
            </nz-select>
          </nz-form-control>
          <ng-template #activeCheck></ng-template>
        </nz-form-item>

        <div class="flex justify-end">
          <button
            nz-button
            nzType="primary"
            *ngIf="isAdd"
            [disabled]="customerForm.invalid"
            [nzLoading]="this.popupButtonLoading"
            (click)="this.isPopUp === true ? this.addCustomerPopup() : this.addCustomer()">
            {{ t('customers.addEdit.buttons.add') }}
          </button>
          <button
            nz-button
            nzType="primary"
            *ngIf="!isAdd"
            [disabled]="customerForm.invalid"
            (click)="editCustomer()">
            {{ t('customers.addEdit.buttons.update') }}
          </button>
        </div>

        <div>
          <nz-alert
            *ngIf="actionMessage.display && actionMessage.isAdd"
            class="mt-2"
            [nzType]="actionMessage.type"
            [nzMessage]="actionMessage.message"
            nzShowIcon
            nzCloseable></nz-alert>
        </div>

      </form>
    </div>
  </div>
</div>
</ng-container>